import { Box } from "@mui/material";
import PageHeader from "../../../../../../../components/PageHeader";
import useRoutePlant from "../../../../../../../hooks/useRoutePlant";
import { BidContextProvider } from "./Bid.context";
import MainBidTab from "./Main";

export default function VendorBidEvaluationPage() {
  const { plant } = useRoutePlant();

  return (
    <BidContextProvider>
      <Box>
        <PageHeader plant={plant} pageTitle="Vendor Bid Evaluation" />
        <Box sx={{ p: 2 }}>
          <MainBidTab />
        </Box>
      </Box>
    </BidContextProvider>
  );
}
